<script>
import CxltToastr from 'cxlt-vue2-toastr'

import Vue from 'vue'

var toastrConfigs = {
      position: 'top right',
      timeOut: 5000,
      showDuration: 0,
      hideDuration: 1000,
      progressBar: true
};
Vue.use(CxltToastr, toastrConfigs);

import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

let AlertType = { success: 'success', error: 'error', warning: 'warning' };

export default{
    showWarning(title, text, context){
        context.$toast.warn({
            title: title,
            message:text
        })
    },
    showSuccess(title, text, context){        
        context.$toast.success({
            title: title,
            message: text
        })
    },
    showError(title, text, context){        
        context.$toast.error({
            title: title,
            message: text
        })
    },
    showNotification(title, text, context, type){   
        if(type == AlertType.success){
            this.showSuccess(title, text, context)
        }
        else if(type == AlertType.warning){
            this.showWarning(title, text, context)
        }
        else if(type == AlertType.error){
            this.showError(title, text, context)
        }
    },
    async showConfirmation(title, contentText, yesCallBack, noCallBack, context)
    {
        context.$swal({
          title: '<i>' + title + '</i>',
          text: contentText,
          //type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then((result) => {
          if(result.value) {
            if(yesCallBack != undefined && yesCallBack != null)
            {
                yesCallBack();
            }
          } else {
            if(noCallBack != undefined && noCallBack != null)
            {
                noCallBack();
            }
          }
        })
    }
}
 
</script>